/**
 * Created by Dhanya Akhil on 3/1/2017.
 */
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { PasswordRoutingModule } from './password-routing.module';
import { PasswordComponent } from './components/password.component';
import {AccountResourceService} from "../../shared/services/account-resource.service";

@NgModule({
  imports: [
    CommonModule,
    PasswordRoutingModule,
    FormsModule,
    TranslateModule.forChild()
  ],
  declarations: [PasswordComponent],
  providers: [AccountResourceService]
})
export class PasswordModule {
}
